webpackJsonp([1],{

/***/ "1VhE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3PU5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8MrG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MPP/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__("/5sW");

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.css
var dist_vuetify = __webpack_require__("QCv7");
var dist_vuetify_default = /*#__PURE__*/__webpack_require__.n(dist_vuetify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/dompurify/dist/purify.js
var purify = __webpack_require__("OvQW");
var purify_default = /*#__PURE__*/__webpack_require__.n(purify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var App = ({
  data: function data() {
    return {
      sideNav: false,
      searchInput: '',
      showFave: false,
      isAnimated: false,
      badge: null
    };
  },

  computed: {
    menuItems: function menuItems() {
      var menuItems = [{ icon: 'weekend', title: 'Products', link: '/products' }, { icon: 'lock_open', title: 'Sign In', link: '/signin' }, { icon: 'create', title: 'Sign Up', link: '/signup' }];
      if (this.userIsAuthenticated) {
        menuItems = [{ icon: 'weekend', title: 'Products', link: '/products' }, { icon: 'account_box', title: 'Profile', link: '/profile' }];
      }
      if (this.userIsAuthenticated && this.userIsAdmin) {
        menuItems = [{ icon: 'stars', title: 'Create Product', link: '/product/new' }];
      }
      return menuItems;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    badgeNumber: function badgeNumber() {
      this.badge = this.$store.getters.user.favoritedProducts.length;
      return this.badge;
    },
    searchResults: function searchResults() {
      var _this = this;

      if (!this.searchInput) {
        return;
      } else if (!this.$store.getters.searchResults.length) {
        return [{ title: 'No results for ' + this.searchInput, description: '' }];
      } else {
        return this.$store.getters.searchResults.map(function (el) {
          var regex = new RegExp(_this.searchInput, 'gi');
          var newTitle = el.title.replace(regex, Object(purify["sanitize"])('<span class="SearchTerm__Highlight">' + _this.searchInput + '</span>'));
          var newDescription = el.description.replace(regex, Object(purify["sanitize"])('<span class="SearchTerm__Highlight">' + _this.searchInput + '</span>'));
          return {
            title: newTitle,
            description: newDescription,
            imageUrl: el.imageUrl,
            id: el.id
          };
        }).slice(0, 5);
      }
    },
    userFavorites: function userFavorites() {
      var faveCopy = [].concat(toConsumableArray_default()(this.$store.getters.user.favoritedProducts));
      return faveCopy.slice(-5);
    },
    products: function products() {
      return this.$store.getters.loadedProducts;
    },
    allProducts: function allProducts() {
      return this.$store.getters.allProducts;
    }
  },
  watch: {
    badge: function badge(favoritedProducts) {
      var _this2 = this;

      this.isAnimated = true;
      setTimeout(function () {
        return _this2.isAnimated = false;
      }, 1000);
    }
  },
  methods: {
    onLogout: function onLogout() {
      this.$store.dispatch('logout');
      this.$router.push('/');
    },
    goToProfile: function goToProfile() {
      this.$router.push('/profile');
    },
    onSearch: function onSearch() {
      this.$store.dispatch('searchProduct', this.searchInput);
    },
    goToProduct: function goToProduct(id) {
      this.$router.push('/products/' + id);
    },
    reloadProducts: function reloadProducts() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.$store.dispatch('setResultsLog', false);

              case 2:
                _context.next = 4;
                return _this3.$store.dispatch('removeProducts', []);

              case 4:
                _context.next = 6;
                return _this3.$store.dispatch('loadProducts', 3);

              case 6:
                _context.next = 8;
                return _this3.$router.push('/products');

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    goToResult: function goToResult(id) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.$store.dispatch('loadProduct', id);

              case 2:
                setTimeout(function () {
                  return _this4.$router.push('/products/' + id);
                }, 0);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  },
  created: function created() {
    this.$store.dispatch('loadProducts', 3);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eee4e67a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"grey lighten-2"},[_c('v-navigation-drawer',{attrs:{"app":"app","temporary":"temporary","fixed":"fixed"},model:{value:(_vm.sideNav),callback:function ($$v) {_vm.sideNav=$$v},expression:"sideNav"}},[_c('v-list',[_vm._l((_vm.menuItems),function(item){return _c('v-list-tile',{key:item.title,attrs:{"to":item.link}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_c('v-list-tile-content',[_vm._v(_vm._s(item.title))])],1)}),(_vm.userIsAuthenticated)?_c('v-list-tile',{on:{"click":_vm.onLogout}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("exit_to_app")])],1),_c('v-list-tile-content',[_vm._v("Logout")])],1):_vm._e()],2)],1),_c('v-toolbar',{staticClass:"deep-purple darken-2",attrs:{"scroll-off-screen":"scroll-off-screen","scroll-threshold":500,"fixed":"fixed","dark":"dark"}},[_c('v-toolbar-side-icon',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.sideNav = !_vm.sideNav}}}),_c('v-toolbar-title',[_c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"to":"/","tag":"span"}},[_vm._v("MCM")])],1),_c('v-text-field',{staticClass:"ml-4 mr-2",attrs:{"flex":"flex","color":"pink lighten-1","width":"30vw","prepend-icon":"search","placeholder":"Search styles","single-line":"single-line","hide-details":"hide-details"},on:{"blur":function($event){_vm.searchInput = ''},"input":_vm.onSearch},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}}),(_vm.searchResults)?_c('v-card',{attrs:{"dark":"dark","id":"Card__Search"}},[_c('v-list',_vm._l((_vm.searchResults),function(result){return _c('v-list-tile',{key:result.title,on:{"click":function($event){_vm.goToResult(result.id)}}},[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(("" + (result.title)))}}),(_vm.userIsAuthenticated && _vm.userFavorites.includes(result.id))?_c('v-list-tile-action',[_c('v-icon',[_vm._v("favorite")])],1):_vm._e()],1)}))],1):_vm._e(),_c('v-toolbar-items',{staticClass:"hidden-xs-only"},[_c('v-btn',{attrs:{"flat":"flat","router":"router"},on:{"click":_vm.reloadProducts}},[_c('v-icon',{staticClass:"hidden-sm-only",attrs:{"left":"left"}},[_vm._v("weekend")]),_vm._v("Products")],1),(_vm.userIsAuthenticated)?_c('v-btn',{attrs:{"flat":"flat"},on:{"mouseenter":function($event){_vm.showFave = true},"mouseleave":function($event){_vm.showFave = false},"click":_vm.goToProfile}},[_c('v-badge',{class:{ 'animate': _vm.isAnimated },attrs:{"color":"blue"}},[(_vm.badgeNumber)?_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.badgeNumber))]):_vm._e(),_c('v-icon',{staticClass:"hidden-sm-only",attrs:{"left":"left"}},[_vm._v("account_box")]),_vm._v("Profile")],1)],1):_vm._e(),_c('v-layout',[_c('v-flex',[(_vm.showFave && _vm.userIsAuthenticated)?_c('v-card',{attrs:{"id":"Card__Favorites"},on:{"mouseover":function($event){_vm.showFave = true},"mouseleave":function($event){_vm.showFave = false}}},[_c('v-list',{staticClass:"mt-2",attrs:{"three-line":"three-line"}},_vm._l((_vm.allProducts),function(product){return (_vm.showFave && _vm.userFavorites.includes(product.id))?_c('v-list-tile',{key:product.title,staticClass:"ml-1 mb-3"},[_c('v-list-tile-content',{staticClass:"Card__Favorites--Image__Container",on:{"click":function($event){_vm.goToResult(product.id)}}},[_c('img',{staticClass:"Card__Favorites--Image",attrs:{"src":product.imageUrl}})])],1):_vm._e()}))],1):_vm._e()],1)],1),(_vm.userIsAuthenticated)?_c('v-btn',{attrs:{"flat":"flat"},on:{"click":_vm.onLogout}},[_c('v-icon',{staticClass:"hidden-sm-only",attrs:{"left":"left"}},[_vm._v("exit_to_app")]),_vm._v("Logout")],1):_vm._e()],1)],1),_c('main',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("ltkf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Home.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Home = ({
  data: function data() {
    return {
      cycleCarousel: true,
      email: '',
      password: '',
      confirmPassword: '',
      signUpInput: null
    };
  },

  computed: {
    error: function error() {
      return this.$store.getters.error;
    },
    products: function products() {
      return this.$store.getters.featuredProducts.sort(function () {
        return .5 - Math.random();
      });
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    comparePasswords: function comparePasswords() {
      if (this.password !== this.confirmPassword) {
        return 'Passwords do not match';
      } else {
        return false;
      }
    },
    isSignUpAlert: function isSignUpAlert() {
      return this.error.message.includes('Sign up');
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/');
      }
    }
  },
  created: function created() {
    window.addEventListener('scroll', this.onFormSlide);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.onFormSlide);
  },

  methods: {
    onLoadProduct: function onLoadProduct(id) {
      this.$router.push('/products/' + id);
    },
    toggleCarousel: function toggleCarousel() {
      this.cycleCarousel = !this.cycleCarousel;
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    },
    onSignup: function onSignup() {
      this.$store.dispatch('signUserUp', { email: this.email, password: this.password });
    },
    onReloadProducts: function onReloadProducts() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch('removeProducts', []);

              case 2:
                _context.next = 4;
                return _this.$store.dispatch('loadProducts', 5);

              case 4:
                _context.next = 6;
                return _this.$router.push('/products');

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onFormSlide: function onFormSlide() {
      var slidingForm = document.querySelector(".slide-in");
      var slideInAt = scrollY + innerHeight - slidingForm.offsetHeight / 2;
      var formBottom = slidingForm.offsetTop + slidingForm.offsetHeight + 1000;
      var half = slideInAt > slidingForm.offsetTop;
      var notScrolledPast = window.scrollY < formBottom;
      if (half && notScrolledPast) {
        slidingForm.classList.add('active');
      } else {
        slidingForm.classList.remove('active');
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    setTimeout(function () {
      return _this2.$store.dispatch('clearError');
    }, 10000);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a26e0eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-xs-center",attrs:{"fluid":"fluid","grid-list-md":"grid-list-md"}},[(_vm.error && !_vm.loading)?_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[(!_vm.isSignUpAlert)?_c('app-alert',{staticClass:"Alert",attrs:{"icon":_vm.error.icon,"color":_vm.error.color,"submessage":_vm.error.submessage,"text":_vm.error.message},on:{"dismissed":_vm.onDismissed}}):_vm._e()],1)],1):_vm._e(),(!_vm.loading)?_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-btn',{staticClass:"darken-4 purple",attrs:{"large":"large","dark":"dark","id":"Products__Button"},on:{"click":_vm.onReloadProducts}},[_vm._v("Explore Products")])],1)],1):_vm._e(),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"xs12"}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"indeterminate","color":"purple","width":7,"size":70}}):_vm._e()],1)],1),(!_vm.loading)?_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-carousel',_vm._b({staticStyle:{"cursor":"pointer","animation-play-state":"paused"},attrs:{"interval":"3000","delimiter-icon":"home","id":"Carousel","lazy":"lazy"}},'v-carousel',{ 'cycle': _vm.cycleCarousel },false),_vm._l((_vm.products),function(product){return _c('v-carousel-item',{key:product.id,attrs:{"src":product.imageUrl},on:{"mouseover":_vm.toggleCarousel,"mouseout":_vm.toggleCarousel,"click":function($event){_vm.onLoadProduct(product.id)}}},[_c('h1',{staticClass:"Carousel__Title"},[_vm._v(_vm._s(product.title))])])})),(!_vm.userIsAuthenticated)?_c('div',{attrs:{"id":"Info__Card"}},[_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('h1',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("Love")]),_vm._v(" Your Home")]),_c('h2',[_vm._v("Find the best curated furniture and home accessories here")])])],1)],1):_vm._e(),(!_vm.userIsAuthenticated)?_c('v-container',{staticClass:"slide-in"},[(!_vm.error)?_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6","offset-sm3":"offset-sm3"}},[_c('h1',[_vm._v("Let's Get Started")]),_c('h3',[_vm._v("Sign up to save your favorites")])])],1):_vm._e(),(_vm.error && !_vm.loading)?_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6","offset-sm3":"offset-sm3"}},[_c('app-alert',{attrs:{"icon":_vm.error.icon,"color":_vm.error.color,"submessage":_vm.error.submessage,"text":_vm.error.message},on:{"dismissed":_vm.onDismissed}})],1)],1):_vm._e(),_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6","offset-sm3":"offset-sm3"}},[_c('v-card',{staticClass:"mt-4 mb-5",attrs:{"color":"purple darken-4","dark":"dark"}},[_c('v-card-text',[_c('v-container',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.onSignup($event)},"input":function($event){_vm.signUpInput = true}}},[_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-text-field',{attrs:{"name":"email","label":"Email","id":"email","type":"email","prepend-icon":"email","required":"required"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-text-field',{attrs:{"name":"password","label":"Password","id":"password","prepend-icon":"extension","type":"password","required":"required"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-text-field',{attrs:{"name":"confirmPassword","label":"Confirm Password","id":"confirmPassword","type":"password","prepend-icon":"gavel","rules":[_vm.comparePasswords],"required":"required"},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-btn',{attrs:{"color":"pink darken-2","dark":"dark","type":"submit","disabled":_vm.loading,"loading":_vm.loading}},[_vm._v("Let's Go!"),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',{attrs:{"light":"light"}},[_vm._v("cached")])],1)])],1)],1)],1)])],1)],1)],1)],1)],1):_vm._e()],1)],1):_vm._e()],1)}
var Home_staticRenderFns = []
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var components_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/components/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("MPP/")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  components_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_components_Home = (Home_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__("+X65");
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Product/Products.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Products = ({
  data: function data() {
    return {
      layoutButtonActive: false,
      pageUpButtonVisible: false,
      description: null,
      mouseInHeart: false,
      unAuthFave: false,
      bottom: false
    };
  },

  computed: {
    products: function products() {
      return this.$store.getters.getProductsWithFlexProperty;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    userIsCreator: function userIsCreator() {
      if (!this.userIsAuthenticated) {
        return false;
      }
      return this.$store.getters.user.id === this.product.creatorId;
    },
    userFavorites: function userFavorites() {
      return this.$store.getters.user.favoritedProducts;
    },
    resultsLog: function resultsLog() {
      return this.$store.getters.resultsLog;
    }
  },
  watch: {
    bottom: function bottom(bottomOfPage) {
      if (bottomOfPage && !this.resultsLog) {
        var throttled = throttle_default()(this.infiniteScroll, 500);
        throttled();
      }
    }
  },
  created: function created() {
    var _this = this;

    window.addEventListener('scroll', function () {
      window.scrollY > 150 ? _this.pageUpButtonVisible = true : _this.pageUpButtonVisible = false;
    });
    window.addEventListener('scroll', function () {
      _this.bottom = _this.bottomVisible();
    });
    this.$store.dispatch('setResultsLog', false);
  },

  methods: {
    infiniteScroll: function infiniteScroll() {
      this.$store.dispatch('infiniteScroll');
    },
    backToTop: function backToTop() {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    },
    goToProduct: function goToProduct(id) {
      if (!this.unAuthFave && !this.mouseInHeart) {
        this.$router.push('/products/' + id);
      }
    },
    bottomVisible: function bottomVisible() {
      var scrollY = window.scrollY;
      var visible = document.documentElement.clientHeight;
      var pageHeight = document.documentElement.scrollHeight;
      var bottomOfPage = visible + scrollY >= pageHeight;
      return bottomOfPage || pageHeight < visible;
    },
    showDescription: function showDescription(product) {
      if (this.products.find(function (el) {
        return el.id === product.id;
      })) {
        this.description = product.description;
      }
    },
    onUnAuthFave: function onUnAuthFave() {
      var _this2 = this;

      this.unAuthFave = true;
      setTimeout(function () {
        return _this2.$router.push('/signup');
      }, 1000);
      setTimeout(function () {
        return _this2.$store.dispatch('unAuthUserClick', { message: 'Sign up to save all your favorites \uD83D\uDC96', submessage: '(it only takes a second \u23F1)', icon: 'info', color: "info" });
      }, 1500);
    },
    toggleLike: function toggleLike(product) {
      if (this.userFavorites.includes(product.id)) {
        this.$store.dispatch('unfavoriteProduct', product.id);
      } else {
        this.$store.dispatch('favoriteProduct', product.id);
      }
    },
    showFirstSentence: function showFirstSentence(description) {
      return description.match(/^[^.]+/)[0];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a6d1094","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product/Products.vue
var Products_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-5 mt-5",attrs:{"grey":"grey","lighten-2":"lighten-2","grid-list-md":"grid-list-md"}},[_c('v-layout',{staticClass:"hidden-xs-only",attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-tooltip',{attrs:{"bottom":"bottom"}},[_c('span',[_vm._v("Row layout")]),_c('v-btn',{attrs:{"slot":"activator","icon":"icon"},on:{"click":function($event){_vm.layoutButtonActive = false}},slot:"activator"},[_c('v-icon',{attrs:{"color":!_vm.layoutButtonActive ? 'purple darken-3' : ''}},[_vm._v("view_headline")])],1)],1),_c('v-tooltip',{attrs:{"bottom":"bottom"}},[_c('span',[_vm._v("Mozaic layout")]),_c('v-btn',{attrs:{"slot":"activator","icon":"icon"},on:{"click":function($event){_vm.layoutButtonActive = true}},slot:"activator"},[_c('v-icon',{attrs:{"color":_vm.layoutButtonActive ? 'purple darken-3' : ''}},[_vm._v("view_quilt")])],1)],1)],1)],1),_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},_vm._l((_vm.products),function(product){return _c('v-flex',_vm._b({key:product.id,attrs:{"xs12":"xs12","hover":"hover"},on:{"mouseenter":function($event){_vm.showDescription(product)},"mouseleave":function($event){_vm.description = null}}},'v-flex',( _obj = {}, _obj[("sm" + (_vm.layoutButtonActive ? product.flex : 6))] = true, _obj ),false),[_c('v-card',{staticClass:"mt-3 ml-1 mr-2",attrs:{"hover":"hover"}},[_c('v-card-media',{key:product.id,attrs:{"lazy":"lazy","src":product.imageUrl,"tag":"button","height":"40vh"},on:{"click":function($event){_vm.goToProduct(product.id)}}},[_c('v-container',{attrs:{"fill-height":"fill-height","fluid":"fluid"}},[_c('v-layout',{attrs:{"fill-height":"fill-height"}},[_c('v-flex',{attrs:{"xs12":"xs12","align-end":"align-end","flexbox":"flexbox"}},[_c('span',{staticClass:"Product__Title headline",domProps:{"textContent":_vm._s(product.title)}}),(product.description === _vm.description)?_c('span',{staticClass:"Product__Description",domProps:{"textContent":_vm._s(_vm.showFirstSentence(_vm.description))}}):_vm._e(),_c('div',[(_vm.userIsAuthenticated)?_c('v-btn',{attrs:{"icon":"icon","x-large":"x-large"},on:{"mouseenter":function($event){_vm.mouseInHeart = true},"mouseleave":function($event){_vm.mouseInHeart = false},"click":function($event){_vm.toggleLike(product)}}},[(_vm.userFavorites.includes(product.id))?_c('v-icon',{attrs:{"color":"red darken-4","x-large":"x-large"}},[_vm._v("favorite")]):_c('v-icon',{attrs:{"color":"grey","x-large":"x-large"}},[_vm._v("favorite")])],1):_vm._e(),(!_vm.userIsAuthenticated)?_c('v-btn',{attrs:{"icon":"icon","x-large":"x-large"},on:{"click":_vm.onUnAuthFave}},[_c('v-icon',{attrs:{"color":"grey","x-large":"x-large"}},[_vm._v("favorite")])],1):_vm._e()],1)])],1)],1)],1)],1)],1)
var _obj;})),(_vm.pageUpButtonVisible)?_c('v-layout',[_c('v-flex',[_c('v-btn',{attrs:{"color":"grey darken-2","dark":"dark","fixed":"fixed","bottom":"bottom","right":"right","fab":"fab"},on:{"click":_vm.backToTop}},[_c('v-icon',[_vm._v("navigation")])],1)],1)],1):_vm._e(),_c('product-skeleton',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading && !_vm.bottom),expression:"loading && !bottom"}]}),(!_vm.loading && _vm.resultsLog)?_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center mt-5 mb-5",attrs:{"xs12":"xs12"}},[_c('h1',[_vm._v("You have reached the end"),_c('v-icon',{staticClass:"ml-3",attrs:{"large":"large","right":"right"}},[_vm._v("sentiment_very_dissatisfied")])],1)])],1):_vm._e()],1)}
var Products_staticRenderFns = []
var Products_esExports = { render: Products_render, staticRenderFns: Products_staticRenderFns }
/* harmony default export */ var Product_Products = (Products_esExports);
// CONCATENATED MODULE: ./src/components/Product/Products.vue
function Products_injectStyle (ssrContext) {
  __webpack_require__("8MrG")
}
var Products_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Products___vue_template_functional__ = false
/* styles */
var Products___vue_styles__ = Products_injectStyle
/* scopeId */
var Products___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Products___vue_module_identifier__ = null
var Products_Component = Products_normalizeComponent(
  Products,
  Product_Products,
  Products___vue_template_functional__,
  Products___vue_styles__,
  Products___vue_scopeId__,
  Products___vue_module_identifier__
)

/* harmony default export */ var components_Product_Products = (Products_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Product/CreateProduct.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CreateProduct = ({
  data: function data() {
    return {
      title: '',
      categories: '',
      imageUrl: '',
      description: '',
      linkTitle: '',
      linkUrl: '',
      links: []
    };
  },

  computed: {
    formIsValid: function formIsValid() {
      return this.title !== '' && this.categories !== '' && this.imageUrl !== '' && this.description !== '' && this.links !== '';
    }
  },
  methods: {
    onCreateProduct: function onCreateProduct() {
      if (!this.formIsValid) {
        return;
      }
      var productData = {
        title: this.title,
        categories: this.categories,
        links: this.links,
        imageUrl: this.imageUrl,
        description: this.description,
        date: new Date()
      };
      this.$store.dispatch('createProduct', productData);
      this.$router.push('/products');
    },
    addLinkObj: function addLinkObj() {
      var linkObj = {
        linkTitle: this.linkTitle,
        linkUrl: this.linkUrl
      };
      this.links.push(linkObj);
      this.linkTitle = '';
      this.linkUrl = '';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cc9346c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product/CreateProduct.vue
var CreateProduct_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"xs12"}},[_c('h1',{staticClass:"primary--text"},[_vm._v("Add a new product")])])],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.onCreateProduct($event)}}},[_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6","offset-sm3":"offset-sm3"}},[_c('v-text-field',{attrs:{"name":"title","label":"Title","id":"title","required":"required"},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6","offset-sm3":"offset-sm3"}},[_c('v-select',{attrs:{"name":"categories","label":"Categories","id":"categories","items":['Mid-Century Modern', 'Rustic', 'Preppy', 'Traditional', 'Arts & Crafts'],"multiple":"multiple","required":"required"},model:{value:(_vm.categories),callback:function ($$v) {_vm.categories=$$v},expression:"categories"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6","offset-sm3":"offset-sm3"}},[_c('v-text-field',{attrs:{"name":"imageUrl","label":"Image URL","id":"image-url","required":"required"},model:{value:(_vm.imageUrl),callback:function ($$v) {_vm.imageUrl=$$v},expression:"imageUrl"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6","offset-sm3":"offset-sm3"}},[_c('img',{attrs:{"src":_vm.imageUrl,"height":"300px"}})])],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6","offset-sm3":"offset-sm3"}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"multi-line","required":"required"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6","offset-sm3":"offset-sm3"}},[_c('v-text-field',{attrs:{"label":"Link Title","id":"linkTitle"},model:{value:(_vm.linkTitle),callback:function ($$v) {_vm.linkTitle=$$v},expression:"linkTitle"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6","offset-sm3":"offset-sm3"}},[_c('v-text-field',{attrs:{"label":"Link Url","id":"linkUrl"},model:{value:(_vm.linkUrl),callback:function ($$v) {_vm.linkUrl=$$v},expression:"linkUrl"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6","offset-sm3":"offset-sm3"}},[_c('v-btn',{on:{"click":_vm.addLinkObj}},[_vm._v("Add Link")]),_vm._l((_vm.links),function(link){return _c('p',[_vm._v(_vm._s(link.linkTitle)+" - "+_vm._s(link.linkUrl))])})],2)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6","offset-sm3":"offset-sm3"}},[_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.formIsValid,"type":"submit"}},[_vm._v("Create Product")])],1)],1)],1)])],1)],1)}
var CreateProduct_staticRenderFns = []
var CreateProduct_esExports = { render: CreateProduct_render, staticRenderFns: CreateProduct_staticRenderFns }
/* harmony default export */ var Product_CreateProduct = (CreateProduct_esExports);
// CONCATENATED MODULE: ./src/components/Product/CreateProduct.vue
var CreateProduct_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var CreateProduct___vue_template_functional__ = false
/* styles */
var CreateProduct___vue_styles__ = null
/* scopeId */
var CreateProduct___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CreateProduct___vue_module_identifier__ = null
var CreateProduct_Component = CreateProduct_normalizeComponent(
  CreateProduct,
  Product_CreateProduct,
  CreateProduct___vue_template_functional__,
  CreateProduct___vue_styles__,
  CreateProduct___vue_scopeId__,
  CreateProduct___vue_module_identifier__
)

/* harmony default export */ var components_Product_CreateProduct = (CreateProduct_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/User/Profile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Profile = ({
  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    userFavorites: function userFavorites() {
      return this.$store.getters.user.favoritedProducts;
    },
    products: function products() {
      return this.$store.getters.allProducts;
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/');
      }
    }
  },
  created: function created() {
    this.$store.dispatch('loadAllProducts');
  },

  methods: {
    goToProduct: function goToProduct(id) {
      this.$store.dispatch('loadProduct', id);
      this.$router.push('/products/' + id);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-364cf567","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Profile.vue
var Profile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-xs-center"},[(!_vm.userFavorites.length)?_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('h1',[_vm._v("You have no favorites currently. Go and add some!")])])],1):_c('v-layout',{staticClass:"mt-5",attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('h1',[_vm._v("Favorited: "+_vm._s(_vm.userFavorites.length))])])],1),_c('v-layout',{staticClass:"wrapper"},_vm._l((_vm.products),function(product){return (_vm.userFavorites.includes(product.id))?_c('v-flex',{key:product.title},[_c('v-card',{attrs:{"hover":"hover"}},[_c('v-card-media',{staticStyle:{"cursor":"pointer"},attrs:{"src":product.imageUrl,"height":"200px","min-width":"100px"},on:{"click":function($event){_vm.goToProduct(product.id)}}}),_c('v-card-text',[_vm._v(_vm._s(product.title))])],1)],1):_vm._e()}))],1)}
var Profile_staticRenderFns = []
var Profile_esExports = { render: Profile_render, staticRenderFns: Profile_staticRenderFns }
/* harmony default export */ var User_Profile = (Profile_esExports);
// CONCATENATED MODULE: ./src/components/User/Profile.vue
function Profile_injectStyle (ssrContext) {
  __webpack_require__("tQcb")
}
var Profile_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Profile___vue_template_functional__ = false
/* styles */
var Profile___vue_styles__ = Profile_injectStyle
/* scopeId */
var Profile___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Profile___vue_module_identifier__ = null
var Profile_Component = Profile_normalizeComponent(
  Profile,
  User_Profile,
  Profile___vue_template_functional__,
  Profile___vue_styles__,
  Profile___vue_scopeId__,
  Profile___vue_module_identifier__
)

/* harmony default export */ var components_User_Profile = (Profile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/User/Signup.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Signup = ({
  data: function data() {
    return {
      email: '',
      password: '',
      confirmPassword: ''
    };
  },

  computed: {
    comparePasswords: function comparePasswords() {
      if (this.password !== this.confirmPassword) {
        return 'Passwords do not match';
      } else {
        return false;
      }
    },
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/');
      }
    }
  },
  methods: {
    onSignup: function onSignup() {
      this.$store.dispatch('signUserUp', { email: this.email, password: this.password });
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f2611f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Signup.vue
var Signup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-xs-center",attrs:{"flexbox":"flexbox","center":"center"}},[(!_vm.error)?_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6","offset-sm3":"offset-sm3"}},[_c('h1',[_vm._v("Get started here")])])],1):_vm._e(),(_vm.error)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6","offset-sm3":"offset-sm3"}},[_c('app-alert',{attrs:{"text":_vm.error.message,"submessage":_vm.error.submessage,"color":_vm.error.color,"icon":_vm.error.icon},on:{"dismissed":_vm.onDismissed}})],1)],1):_vm._e(),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6","offset-sm3":"offset-sm3"}},[_c('v-card',[_c('v-card-text',[_c('v-container',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.onSignup($event)}}},[_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-text-field',{attrs:{"name":"email","label":"Email","id":"email","type":"email","prepend-icon":"email","required":"required"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-text-field',{attrs:{"name":"password","label":"Password","id":"password","prepend-icon":"extension","type":"password","required":"required"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-text-field',{attrs:{"name":"confirmPassword","label":"Confirm Password","id":"confirmPassword","type":"password","prepend-icon":"gavel","rules":[_vm.comparePasswords],"required":"required"},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-btn',{attrs:{"color":"blue","dark":"dark","type":"submit","disabled":_vm.loading,"loading":_vm.loading}},[_vm._v("Sign Up"),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',{attrs:{"light":"light"}},[_vm._v("cached")])],1)]),_c('h3',[_vm._v("Already have an account? "),_c('router-link',{attrs:{"to":"/signin"}},[_vm._v("Sign in")])],1)],1)],1)],1)])],1)],1)],1)],1)],1)}
var Signup_staticRenderFns = []
var Signup_esExports = { render: Signup_render, staticRenderFns: Signup_staticRenderFns }
/* harmony default export */ var User_Signup = (Signup_esExports);
// CONCATENATED MODULE: ./src/components/User/Signup.vue
function Signup_injectStyle (ssrContext) {
  __webpack_require__("1VhE")
}
var Signup_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Signup___vue_template_functional__ = false
/* styles */
var Signup___vue_styles__ = Signup_injectStyle
/* scopeId */
var Signup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Signup___vue_module_identifier__ = null
var Signup_Component = Signup_normalizeComponent(
  Signup,
  User_Signup,
  Signup___vue_template_functional__,
  Signup___vue_styles__,
  Signup___vue_scopeId__,
  Signup___vue_module_identifier__
)

/* harmony default export */ var components_User_Signup = (Signup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/User/Signin.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Signin = ({
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/');
      }
    }
  },
  methods: {
    onSignin: function onSignin() {
      this.$store.dispatch('signUserIn', { email: this.email, password: this.password });
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-040f5e25","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Signin.vue
var Signin_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-xs-center",attrs:{"flexbox":"flexbox","center":"center"}},[(!_vm.error)?_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6","offset-sm3":"offset-sm3"}},[_c('h1',[_vm._v("Welcome Back!")])])],1):_vm._e(),(_vm.error)?_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6","offset-sm3":"offset-sm3"}},[_c('app-alert',{attrs:{"text":_vm.error.message,"color":_vm.error.color,"icon":_vm.error.icon},on:{"dismissed":_vm.onDismissed}})],1)],1):_vm._e(),_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6","offset-sm3":"offset-sm3"}},[_c('v-card',[_c('v-card-text',[_c('v-container',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.onSignin($event)}}},[_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-text-field',{attrs:{"name":"email","prepend-icon":"email","label":"Email","id":"email","type":"email","required":"required"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-text-field',{attrs:{"name":"password","label":"Password","id":"password","prepend-icon":"extension","type":"password","required":"required"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-btn',{attrs:{"type":"submit","disabled":_vm.loading,"loading":_vm.loading,"color":"orange"}},[_vm._v("Sign in"),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',{attrs:{"light":"light"}},[_vm._v("cached")])],1)]),_c('h3',[_vm._v("Don't have an account? "),_c('router-link',{attrs:{"to":"/signup"}},[_vm._v("Sign up")])],1)],1)],1)],1)])],1)],1)],1)],1)],1)}
var Signin_staticRenderFns = []
var Signin_esExports = { render: Signin_render, staticRenderFns: Signin_staticRenderFns }
/* harmony default export */ var User_Signin = (Signin_esExports);
// CONCATENATED MODULE: ./src/components/User/Signin.vue
var Signin_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Signin___vue_template_functional__ = false
/* styles */
var Signin___vue_styles__ = null
/* scopeId */
var Signin___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Signin___vue_module_identifier__ = null
var Signin_Component = Signin_normalizeComponent(
  Signin,
  User_Signin,
  Signin___vue_template_functional__,
  Signin___vue_styles__,
  Signin___vue_scopeId__,
  Signin___vue_module_identifier__
)

/* harmony default export */ var components_User_Signin = (Signin_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Product/Product.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Product = ({
  props: ['id'],
  data: function data() {
    return {
      dialog: false,
      unAuthFave: false,
      mouseEnterHeart: false,
      isAnimating: false
    };
  },

  computed: {
    product: function product() {
      return this.$store.getters.loadedProduct(this.id);
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    heartLoading: function heartLoading() {
      return this.$store.getters.heartLoading;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    userIsCreator: function userIsCreator() {
      if (!this.userIsAuthenticated) {
        return false;
      }
      return this.$store.getters.user.id === this.product.creatorId;
    },
    onProductLiked: function onProductLiked() {
      return this.$store.getters.user.favoritedProducts.includes(this.product.id);
    },
    allProducts: function allProducts() {
      return this.$store.getters.allProducts;
    }
  },
  created: function created() {
    this.$store.dispatch('loadProduct', this.id);
  },

  methods: {
    onAgree: function onAgree() {
      if (this.onProductLiked) {
        if (window.scrollY > 25) {
          this.isAnimating = true;
        }
        this.$store.dispatch('unfavoriteProduct', this.product.id);
      } else {
        if (window.scrollY > 25) {
          this.isAnimating = true;
        }
        this.$store.dispatch('favoriteProduct', this.product.id);
      }
    },
    onUnAuthFave: function onUnAuthFave() {
      var _this = this;

      if (scrollY > 25) {
        this.isAnimating = true;
        this.unAuthFave = true;
      }
      this.unAuthFave = true;
      setTimeout(function () {
        return _this.$router.push('/signup');
      }, 1000);
      setTimeout(function () {
        return _this.$store.dispatch('unAuthUserClick', { message: 'Sign up to save all your favorites \uD83D\uDC96', submessage: '(it only takes a second \u23F1)', icon: 'info', color: "info" });
      }, 1500);
    },
    togglePictureDialog: function togglePictureDialog() {
      if (window.innerWidth > 500 && !this.unAuthFave && !this.mouseEnterHeart) {
        this.dialog = !this.dialog;
      }
    },
    navBack: function navBack() {
      this.$router.go(-1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d5cf92c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product/Product.vue
var Product_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-5 mb-5",attrs:{"flexbox":"flexbox","center":"center"}},[(_vm.loading)?_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"xs12"}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"indeterminate","color":"purple","width":7,"size":70}}):_vm._e()],1)],1):_vm._e(),(!_vm.loading)?_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-card',{attrs:{"hover":"hover"}},[_c('v-card-title',[_c('h1',{staticClass:"Product__Title"},[_vm._v(_vm._s(_vm.product.title))]),_c('v-spacer'),_c('v-btn',{attrs:{"dark":"dark","color":"purple darken-4"},on:{"click":_vm.navBack}},[_c('v-icon',[_vm._v("arrow_back")])],1)],1),_c('v-tooltip',{attrs:{"right":"right"}},[_c('span',[_vm._v("Click to enlarge image")]),_c('v-card-media',{staticStyle:{"height":"200px","width":"100%","object-fit":"contain"},attrs:{"slot":"activator","src":_vm.product.imageUrl,"id":"media"},on:{"click":_vm.togglePictureDialog},slot:"activator"},[(_vm.unAuthFave && !_vm.isAnimating)?_c('heart-flutter',{attrs:{"id":"heart-flutter"}}):_vm._e(),(_vm.heartLoading && !_vm.isAnimating)?_c('heart-flutter',{attrs:{"id":"heart-flutter"}}):_vm._e(),(_vm.userIsAuthenticated && !_vm.userIsCreator)?_c('v-btn',{attrs:{"icon":"icon","x-large":"x-large"},on:{"mouseenter":function($event){_vm.mouseEnterHeart = true},"mouseleave":function($event){_vm.mouseEnterHeart = false},"click":_vm.onAgree}},[(_vm.onProductLiked)?_c('v-icon',{attrs:{"color":"red darken-4","x-large":"x-large"}},[_vm._v("favorite")]):_c('v-icon',{attrs:{"color":"grey","x-large":"x-large"}},[_vm._v("favorite")])],1):_vm._e(),(!_vm.userIsAuthenticated)?_c('v-btn',{attrs:{"icon":"icon","x-large":"x-large"},on:{"click":_vm.onUnAuthFave}},[_c('v-icon',{attrs:{"x-large":"x-large","color":"grey"}},[_vm._v("favorite")])],1):_vm._e()],1)],1),_c('v-dialog',{model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-media',{attrs:{"src":_vm.product.imageUrl,"height":"500px"}})],1)],1),_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.product.description))])]),_c('v-card-actions',_vm._l((_vm.product.links),function(link){return _c('v-btn',{key:link.linkTitle,staticClass:"deep-purple darken-2",attrs:{"flat":"flat","dark":"dark","round":"round","href":link.linkUrl}},[_vm._v(_vm._s(link.linkTitle))])}))],1)],1)],1):_vm._e()],1)}
var Product_staticRenderFns = []
var Product_esExports = { render: Product_render, staticRenderFns: Product_staticRenderFns }
/* harmony default export */ var Product_Product = (Product_esExports);
// CONCATENATED MODULE: ./src/components/Product/Product.vue
function Product_injectStyle (ssrContext) {
  __webpack_require__("3PU5")
}
var Product_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Product___vue_template_functional__ = false
/* styles */
var Product___vue_styles__ = Product_injectStyle
/* scopeId */
var Product___vue_scopeId__ = "data-v-7d5cf92c"
/* moduleIdentifier (server only) */
var Product___vue_module_identifier__ = null
var Product_Component = Product_normalizeComponent(
  Product,
  Product_Product,
  Product___vue_template_functional__,
  Product___vue_styles__,
  Product___vue_scopeId__,
  Product___vue_module_identifier__
)

/* harmony default export */ var components_Product_Product = (Product_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/set.js
var set = __webpack_require__("lHA8");
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/reflect/delete-property.js
var delete_property = __webpack_require__("uqrR");
var delete_property_default = /*#__PURE__*/__webpack_require__.n(delete_property);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/firebase/index.js
var firebase = __webpack_require__("Sazm");
var firebase_default = /*#__PURE__*/__webpack_require__.n(firebase);

// CONCATENATED MODULE: ./src/store/index.js









vue_runtime_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var store = new vuex_esm["a" /* default */].Store({
  state: {
    loadedProducts: [],
    allProducts: [],
    allProductsFiltered: [],
    user: null,
    loading: null,
    heartLoading: null,
    error: null,
    searchResults: [],
    productLiked: null,
    oldestKey: "",
    justSignedIn: null,
    resultsLog: null,
    flag: null,
    productIndex: null,
    lastKeys: []
  },
  mutations: {
    favoriteProduct: function favoriteProduct(state, payload) {
      var id = payload.id;
      var time = payload.timeFavorited;
      if (state.user.favoritedProducts.findIndex(function (product) {
        return product.id === id;
      }) >= 0) {
        return;
      }
      state.user.favoritedProducts.push(id);
      state.user.fbKeys[id] = payload.fbKey;
    },
    unfavoriteProduct: function unfavoriteProduct(state, payload) {
      var faveProducts = state.user.favoritedProducts;
      faveProducts.splice(faveProducts.indexOf(payload), 1);
      delete_property_default()(state.user.fbKeys, payload);
    },
    createProduct: function createProduct(state, payload) {
      state.loadedProducts.push(payload);
    },
    updateProduct: function updateProduct(state, payload) {
      var product = state.loadedProducts.find(function (product) {
        return product.id === payload.id;
      });
      if (payload.title) {
        product.title = payload.title;
      }
      if (payload.description) {
        product.description = payload.description;
      }
    },
    setUser: function setUser(state, payload) {
      state.user = payload;
    },
    setLoading: function setLoading(state, payload) {
      state.loading = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    },
    clearError: function clearError(state) {
      state.error = null;
    },
    setLoadedProducts: function setLoadedProducts(state, payload) {
      var _state$loadedProducts;

      (_state$loadedProducts = state.loadedProducts).push.apply(_state$loadedProducts, toConsumableArray_default()(payload));
    },
    removeProducts: function removeProducts(state, payload) {
      state.loadedProducts = payload;
    },
    setSearchResults: function setSearchResults(state, payload) {
      state.searchResults = payload;
    },
    setOldestKey: function setOldestKey(state, payload) {
      state.oldestKey = payload;
    },
    setHeartLoading: function setHeartLoading(state, payload) {
      state.heartLoading = payload;
    },
    setResultsLog: function setResultsLog(state, payload) {
      state.resultsLog = payload;
    },
    setAllProducts: function setAllProducts(state, payload) {
      state.allProducts = payload;
    },
    setFlag: function setFlag(state, payload) {
      state.flag = payload;
    },
    setProductIndex: function setProductIndex(state, payload) {
      state.productIndex = payload;
    },
    setLastKeys: function setLastKeys(state, payload) {
      state.lastKeys = payload;
    },
    filterAllProducts: function filterAllProducts(state, payload) {
      var slicedArray = [].concat(toConsumableArray_default()(state.allProducts)).filter(function (el) {
        return payload.includes(el.id);
      });
      var hash = {};
      slicedArray.forEach(function (x) {
        hash[x.id] = x;
      });
      state.allProductsFiltered = payload.map(function (x) {
        return hash[x];
      });
    }
  },
  actions: {
    loadAllProducts: function loadAllProducts(_ref) {
      var commit = _ref.commit;

      commit("setLoading", true);
      firebase["database"]().ref("products").orderByKey().once("value").then(function (data) {
        var products = [];
        var obj = data.val();
        for (var key in obj) {
          products.push({
            id: key,
            title: obj[key].title,
            categories: obj[key].categories,
            imageUrl: obj[key].imageUrl,
            description: obj[key].description,
            links: obj[key].links,
            date: obj[key].date,
            creatorId: obj[key].creatorId
          });
        }
        commit("setAllProducts", products.reverse());
        commit("setLoading", false);
      }).catch(function (error) {
        commit("setLoading", false);
        console.log(error);
      });
    },
    loadProduct: function loadProduct(_ref2, payload) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      commit("setLoading", true);
      firebase["database"]().ref("/products/" + payload).once("value").then(function (data) {
        var obj = data.val();
        var key = data.key;
        var product = extends_default()({ id: key }, obj);
        var productLoaded = getters.loadedProducts.findIndex(function (product) {
          return product.id === payload;
        }) !== -1;
        if (!productLoaded) {
          getters.loadedProducts.push(product);
        }
        commit("setLoading", false);
      }).catch(function (error) {
        commit("setLoading", false);
        console.log(error);
      });
    },
    loadProducts: function loadProducts(_ref3) {
      var commit = _ref3.commit;
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;

      commit("setLoading", true);
      var oldestKey = void 0;
      firebase["database"]().ref("products").orderByKey().limitToLast(payload).once("value").then(function (data) {
        var products = [];
        var obj = data.val();
        for (var key in obj) {
          products.push({
            id: key,
            title: obj[key].title,
            categories: obj[key].categories,
            imageUrl: obj[key].imageUrl,
            description: obj[key].description,
            links: obj[key].links,
            date: obj[key].date,
            creatorId: obj[key].creatorId
          });
        }
        var arrayOfKeys = keys_default()(obj);
        oldestKey = arrayOfKeys[0];
        commit("setLoadedProducts", products.reverse());
        commit("setOldestKey", oldestKey);
        commit("setLoading", false);
      }).catch(function (error) {
        commit("setLoading", false);
        console.log(error);
      });
    },
    infiniteScroll: function infiniteScroll(_ref4) {
      var commit = _ref4.commit,
          getters = _ref4.getters;

      commit("setLoading", true);
      firebase["database"]().ref("products").orderByKey().endAt(getters.oldestKey).limitToLast(5).once("value").then(function (data) {
        var products = [];
        var obj = data.val();
        for (var key in obj) {
          products.push({
            id: key,
            title: obj[key].title,
            categories: obj[key].categories,
            imageUrl: obj[key].imageUrl,
            description: obj[key].description,
            links: obj[key].links,
            date: obj[key].date,
            creatorId: obj[key].creatorId
          });
        }
        var slice = products.reverse().slice(1);
        var arrayOfKeys = keys_default()(obj);

        getters.lastKeys.push(arrayOfKeys[0]);
        getters.lastKeys.splice(-3, getters.lastKeys.length - 2);
        if (getters.lastKeys[getters.lastKeys.length - 1] === getters.lastKeys[getters.lastKeys.length - 2]) {
          commit("setLoading", false);
          commit("setResultsLog", true);
          commit("setLastKeys", []);
          return;
        }
        commit("setOldestKey", arrayOfKeys[0]);
        commit("setLoadedProducts", slice);
        commit("setLoading", false);
      });
    },
    searchProduct: function searchProduct(_ref5, payload) {
      var commit = _ref5.commit;

      firebase["database"]().ref("products").orderByValue().on("value", function (snapshot) {
        var keysArray = snapshot.val();
        var arr = [];
        for (var key in keysArray) {
          arr.push({
            id: key,
            title: keysArray[key].title,
            description: keysArray[key].description,
            imageUrl: keysArray[key].imageUrl
          });
        }
        var results = arr.filter(function (el) {
          var regex = new RegExp(payload, "gi");
          if (el.title.match(regex) || el.description.match(regex)) {
            return el;
          }
        });
        commit("setSearchResults", results);
      });
    },
    favoriteProduct: function favoriteProduct(_ref6, payload) {
      var commit = _ref6.commit,
          getters = _ref6.getters;

      commit("setHeartLoading", true);
      var user = getters.user;
      firebase["database"]().ref("/users/" + user.id).child("/favorites/").push(payload).then(function (data) {
        commit("favoriteProduct", {
          id: payload,
          timeFavorited: new Date(),
          fbKey: data.key
        });
        setTimeout(function () {
          return commit("setHeartLoading", false);
        }, 1200);
        commit("setLoading", false);
      }).catch(function (error) {
        commit("setLoading", false);
        console.log(error);
      });
    },
    unfavoriteProduct: function unfavoriteProduct(_ref7, payload) {
      var commit = _ref7.commit,
          getters = _ref7.getters;

      var user = getters.user;
      var fbKey = user.fbKeys[payload];
      firebase["database"]().ref("/users/" + user.id + "/favorites/").child(fbKey).remove().then(function (data) {
        commit("unfavoriteProduct", payload);
      }).catch(function (error) {
        console.log(error);
      });
    },
    createProduct: function createProduct(_ref8, payload) {
      var commit = _ref8.commit,
          getters = _ref8.getters;

      var product = {
        title: payload.title,
        categories: payload.categories,
        imageUrl: payload.imageUrl,
        description: payload.description,
        links: payload.links,
        date: payload.date.toISOString(),
        creatorId: getters.user.id
      };
      firebase["database"]().ref("products").push(product).then(function (data) {
        var key = data.key;
        commit("createProduct", extends_default()({}, product, { id: key }));
      }).catch(function (error) {
        console.log(error);
      });
    },
    updateProductData: function updateProductData(_ref9, payload) {
      var commit = _ref9.commit;

      commit("setLoading", true);
      var updateObj = {};
      if (payload.title) {
        updateObj.title = payload.title;
      }
      if (payload.description) {
        updateObj.description = payload.description;
      }
      firebase["database"]().ref("products").child(payload.id).update(updateObj).then(function () {
        commit("setLoading", false);
        commit("updateProduct", payload);
      }).catch(function (error) {
        commit("setLoading", false);
        console.log(error);
      });
    },
    signUserUp: function signUserUp(_ref10, payload) {
      var commit = _ref10.commit;

      commit("setLoading", true);
      commit("clearError");
      firebase["auth"]().createUserWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        commit("setLoading", false);
        var newUser = {
          id: user.uid,
          favoritedProducts: [],
          fbKeys: {}
        };
        commit("setUser", newUser);
        commit("setError", {
          message: "You are now signed up!!",
          icon: "check_circle",
          color: "green"
        });
      }).catch(function (error) {
        commit("setLoading", false);
        commit("setError", error);
        console.log(error);
      });
    },
    signUserIn: function signUserIn(_ref11, payload) {
      var commit = _ref11.commit;

      commit("setLoading", true);
      commit("clearError");
      firebase["auth"]().signInWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        commit("setLoading", false);
        var newUser = {
          id: user.uid,
          favoritedProducts: [],
          fbKeys: {}
        };
        commit("setUser", newUser);
        commit("setError", {
          message: "\uD83C\uDF89  You are now signed in  \uD83C\uDF89",
          icon: "check_circle",
          color: "green"
        });
      }).catch(function (error) {
        commit("setLoading", false);
        commit("setError", error);
        console.log(error);
      });
    },
    autoSignIn: function autoSignIn(_ref12, payload) {
      var commit = _ref12.commit;

      commit("setUser", {
        id: payload.uid,
        favoritedProducts: [],
        fbKeys: {}
      });
    },
    fetchUserData: function fetchUserData(_ref13) {
      var commit = _ref13.commit,
          getters = _ref13.getters;

      commit("setLoading", true);
      firebase["database"]().ref("/users/" + getters.user.id + "/favorites/").once("value").then(function (data) {
        var dataPairs = data.val();
        var favoritedProducts = [];
        var swappedPairs = {};
        for (var key in dataPairs) {
          favoritedProducts.push(dataPairs[key]);
          swappedPairs[dataPairs[key]] = key;
        }
        var updatedUser = {
          id: getters.user.id,
          favoritedProducts: favoritedProducts,
          fbKeys: swappedPairs
        };
        commit("setLoading", false);
        commit("setUser", updatedUser);
      }).catch(function (error) {
        commit("setLoading", false);
        console.log(error);
      });
    },
    logout: function logout(_ref14) {
      var commit = _ref14.commit;

      firebase["auth"]().signOut();
      commit("setUser", null);
    },
    clearError: function clearError(_ref15) {
      var commit = _ref15.commit;

      commit("clearError");
    },
    unAuthUserClick: function unAuthUserClick(_ref16, payload) {
      var commit = _ref16.commit;

      commit("setError", payload);
    },
    setFlag: function setFlag(_ref17, payload) {
      var commit = _ref17.commit;

      commit("setFlag", payload);
    },
    removeProducts: function removeProducts(_ref18, payload) {
      var commit = _ref18.commit,
          getters = _ref18.getters;

      commit("removeProducts", []);
    },
    setProductIndex: function setProductIndex(_ref19, payload) {
      var commit = _ref19.commit;

      commit("setProductIndex", payload);
    },
    setResultsLog: function setResultsLog(_ref20, payload) {
      var commit = _ref20.commit;

      commit("setResultsLog", payload);
    },
    filterAllProducts: function filterAllProducts(_ref21, payload) {
      var commit = _ref21.commit;

      commit("filterAllProducts", payload);
    }
  },
  getters: {
    loadedProducts: function loadedProducts(state) {
      var loadedProducts = state.loadedProducts;
      loadedProducts.sort(function (productA, productB) {
        return productA.date < productB.date;
      });
      return loadedProducts;
    },
    loadedProduct: function loadedProduct(state) {
      return function (productId) {
        return state.loadedProducts.find(function (product) {
          return product.id === productId;
        });
      };
    },
    featuredProducts: function featuredProducts(state, getters) {
      return getters.loadedProducts.slice(0, 5);
    },
    getProductsWithFlexProperty: function getProductsWithFlexProperty(state, getters) {
      var loadedProducts = getters.loadedProducts;
      loadedProducts.forEach(function (el, i) {
        if (i % 3) {
          el["flex"] = 6;
        } else {
          el["flex"] = 12;
        }
      });
      return [].concat(toConsumableArray_default()(new set_default.a(loadedProducts)));
    },
    user: function user(state) {
      return state.user;
    },
    loading: function loading(state) {
      return state.loading;
    },
    error: function error(state) {
      return state.error;
    },
    searchResults: function searchResults(state) {
      return state.searchResults;
    },
    oldestKey: function oldestKey(state) {
      return state.oldestKey;
    },
    heartLoading: function heartLoading(state) {
      return state.heartLoading;
    },
    resultsLog: function resultsLog(state) {
      return state.resultsLog;
    },
    allProducts: function allProducts(state) {
      return state.allProducts;
    },
    allProductsFiltered: function allProductsFiltered(state) {
      return state.allProductsFiltered;
    },
    flag: function flag(state) {
      return state.flag;
    },
    productIndex: function productIndex(state) {
      return state.productIndex;
    },
    lastKeys: function lastKeys(state) {
      return state.lastKeys;
    }
  }
});
// CONCATENATED MODULE: ./src/router/auth-guard.js


/* harmony default export */ var auth_guard = (function (to, from, next) {
  if (store.getters.user) {
    next();
  } else {
    next("/signin");
  }
});
// CONCATENATED MODULE: ./src/router/index.js











vue_runtime_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: "/",
    name: "Home",
    component: src_components_Home
  }, {
    path: "/products",
    name: "Products",
    component: components_Product_Products
  }, {
    path: "/product/new",
    name: "CreateProduct",
    component: components_Product_CreateProduct,
    beforeEnter: auth_guard
  }, {
    path: "/products/:id",
    name: "Product",
    props: true,
    component: components_Product_Product
  }, {
    path: "/profile",
    name: "Profile",
    component: components_User_Profile,
    beforeEnter: auth_guard
  }, {
    path: "/signup",
    name: "Signup",
    component: components_User_Signup
  }, {
    path: "/signin",
    name: "Signin",
    component: components_User_Signin
  }],
  mode: "history"
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Shared/Alert.vue
//
//
//
//
//
//

/* harmony default export */ var Alert = ({
  props: ['text', 'submessage', 'icon', 'color'],
  data: function data() {
    return {
      hideAlert: false
    };
  },

  methods: {
    onClose: function onClose() {
      var _this = this;

      this.hideAlert = !this.hideAlert;
      setTimeout(function () {
        return _this.$emit('dismissed');
      }, 1000);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c34dc462","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Alert.vue
var Alert_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{class:{ 'hide' : _vm.hideAlert },attrs:{"icon":_vm.icon,"dark":"dark","color":_vm.color,"dismissible":"dismissible","value":true},on:{"input":_vm.onClose}},[_c('h3',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.text))]),_c('h4',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.submessage))])])}
var Alert_staticRenderFns = []
var Alert_esExports = { render: Alert_render, staticRenderFns: Alert_staticRenderFns }
/* harmony default export */ var Shared_Alert = (Alert_esExports);
// CONCATENATED MODULE: ./src/components/Shared/Alert.vue
function Alert_injectStyle (ssrContext) {
  __webpack_require__("tlyz")
}
var Alert_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Alert___vue_template_functional__ = false
/* styles */
var Alert___vue_styles__ = Alert_injectStyle
/* scopeId */
var Alert___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Alert___vue_module_identifier__ = null
var Alert_Component = Alert_normalizeComponent(
  Alert,
  Shared_Alert,
  Alert___vue_template_functional__,
  Alert___vue_styles__,
  Alert___vue_scopeId__,
  Alert___vue_module_identifier__
)

/* harmony default export */ var components_Shared_Alert = (Alert_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Product/Edit/EditProductDetailsDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var EditProductDetailsDialog = ({
  props: ['product'],
  data: function data() {
    return {
      editDialog: false,
      editedTitle: this.product.title,
      editedDescription: this.product.description
    };
  },

  methods: {
    onSaveChanges: function onSaveChanges() {
      if (this.editedTitle.trim() === '' || this.editedDescription.trim() === '') this.editDialog = false;
      this.$store.dispatch('updateProductData', {
        id: this.product.id,
        title: this.editedTitle,
        description: this.editedDescription
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a907f21","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product/Edit/EditProductDetailsDialog.vue
var EditProductDetailsDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"350px","persistent":"persistent"},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-btn',{attrs:{"slot":"activator","floating":"floating","accent":"accent"},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1),_c('v-card',[_c('v-container',[_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-card-title',[_vm._v("Edit Product")])],1)],1),_c('v-divider'),_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-card-text',[_c('v-text-field',{attrs:{"name":"title","label":"Title","required":"required"},model:{value:(_vm.editedTitle),callback:function ($$v) {_vm.editedTitle=$$v},expression:"editedTitle"}}),_c('v-text-field',{attrs:{"name":"description","label":"Description","multi-line":"multi-line","required":"required"},model:{value:(_vm.editedDescription),callback:function ($$v) {_vm.editedDescription=$$v},expression:"editedDescription"}})],1)],1)],1),_c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12"}},[_c('v-card-actions',[_c('v-btn',{staticClass:"blue--text",attrs:{"flat":"flat"},on:{"click":function($event){_vm.editDialog = false}}},[_vm._v("Close")]),_c('v-btn',{staticClass:"red--text",attrs:{"flat":"flat"},on:{"click":_vm.onSaveChanges}},[_vm._v("Save")])],1)],1)],1)],1)],1)],1)}
var EditProductDetailsDialog_staticRenderFns = []
var EditProductDetailsDialog_esExports = { render: EditProductDetailsDialog_render, staticRenderFns: EditProductDetailsDialog_staticRenderFns }
/* harmony default export */ var Edit_EditProductDetailsDialog = (EditProductDetailsDialog_esExports);
// CONCATENATED MODULE: ./src/components/Product/Edit/EditProductDetailsDialog.vue
var EditProductDetailsDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditProductDetailsDialog___vue_template_functional__ = false
/* styles */
var EditProductDetailsDialog___vue_styles__ = null
/* scopeId */
var EditProductDetailsDialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditProductDetailsDialog___vue_module_identifier__ = null
var EditProductDetailsDialog_Component = EditProductDetailsDialog_normalizeComponent(
  EditProductDetailsDialog,
  Edit_EditProductDetailsDialog,
  EditProductDetailsDialog___vue_template_functional__,
  EditProductDetailsDialog___vue_styles__,
  EditProductDetailsDialog___vue_scopeId__,
  EditProductDetailsDialog___vue_module_identifier__
)

/* harmony default export */ var Product_Edit_EditProductDetailsDialog = (EditProductDetailsDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfaeb1f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Heart.vue
var Heart_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"heart"},[_c('svg',{attrs:{"width":"80","height":"80","viewBox":"0 0 800 700","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m263.42 235.15c-66.24 0-120 53.76-120 120 0 134.76 135.93 170.09 228.56 303.31 87.574-132.4 228.56-172.86 228.56-303.31 0-66.24-53.76-120-120-120-48.048 0-89.402 28.37-108.56 69.188-19.161-40.817-60.514-69.188-108.56-69.188z"}})])]),_vm._v(" "),_c('div',{staticClass:"heart"},[_c('svg',{attrs:{"width":"60","height":"60","viewBox":"0 0 800 700","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m263.42 235.15c-66.24 0-120 53.76-120 120 0 134.76 135.93 170.09 228.56 303.31 87.574-132.4 228.56-172.86 228.56-303.31 0-66.24-53.76-120-120-120-48.048 0-89.402 28.37-108.56 69.188-19.161-40.817-60.514-69.188-108.56-69.188z"}})])]),_vm._v(" "),_c('div',{staticClass:"heart"},[_c('svg',{attrs:{"width":"56","height":"56","viewBox":"0 0 800 700","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m263.42 235.15c-66.24 0-120 53.76-120 120 0 134.76 135.93 170.09 228.56 303.31 87.574-132.4 228.56-172.86 228.56-303.31 0-66.24-53.76-120-120-120-48.048 0-89.402 28.37-108.56 69.188-19.161-40.817-60.514-69.188-108.56-69.188z"}})])])])}
var Heart_staticRenderFns = []
var Heart_esExports = { render: Heart_render, staticRenderFns: Heart_staticRenderFns }
/* harmony default export */ var Heart = (Heart_esExports);
// CONCATENATED MODULE: ./src/components/Shared/Heart.vue
function Heart_injectStyle (ssrContext) {
  __webpack_require__("p646")
}
var Heart_normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var Heart___vue_template_functional__ = false
/* styles */
var Heart___vue_styles__ = Heart_injectStyle
/* scopeId */
var Heart___vue_scopeId__ = "data-v-bfaeb1f6"
/* moduleIdentifier (server only) */
var Heart___vue_module_identifier__ = null
var Heart_Component = Heart_normalizeComponent(
  __vue_script__,
  Heart,
  Heart___vue_template_functional__,
  Heart___vue_styles__,
  Heart___vue_scopeId__,
  Heart___vue_module_identifier__
)

/* harmony default export */ var Shared_Heart = (Heart_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39811339","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/ProductSkeleton.vue
var ProductSkeleton_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},[_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6"}},[_c('v-card',{staticClass:"mt-3 ml-1 mr-2",attrs:{"hover":"hover"}},[_c('v-card-media',{staticClass:"grey",attrs:{"height":"40vh","id":"skeleton"}},[_c('v-container',{attrs:{"fill-height":"fill-height","fluid":"fluid"}},[_c('v-layout',{attrs:{"fill-height":"fill-height"}},[_c('v-flex',{attrs:{"xs12":"xs12","align-end":"align-end","flexbox":"flexbox"}},[_c('span',{staticClass:"Product__Skeleton--Headline headline"},[_vm._v("Product Skeleton")]),_c('span',{staticClass:"Product__Skeleton--Description"}),_c('div',[_c('v-btn',{attrs:{"x-large":"x-large","icon":"icon"}},[_c('v-icon',{attrs:{"color":"gray darken-3","x-large":"x-large"}},[_vm._v("favorite")])],1)],1)])],1)],1)],1)],1)],1),_c('v-flex',{attrs:{"xs12":"xs12","sm6":"sm6"}},[_c('v-card',{staticClass:"mt-3 ml-1 mr-2",attrs:{"hover":"hover"}},[_c('v-card-media',{staticClass:"grey",attrs:{"height":"40vh","id":"skeleton"}},[_c('v-container',{attrs:{"fill-height":"fill-height","fluid":"fluid"}},[_c('v-layout',{attrs:{"fill-height":"fill-height"}},[_c('v-flex',{attrs:{"xs12":"xs12","align-end":"align-end","flexbox":"flexbox"}},[_c('span',{staticClass:"Product__Skeleton--Headline headline"},[_vm._v("Product Skeleton")]),_c('span',{staticClass:"Product__Skeleton--Description"}),_c('div',[_c('v-btn',{attrs:{"x-large":"x-large","icon":"icon"}},[_c('v-icon',{attrs:{"color":"gray darken-3","x-large":"x-large"}},[_vm._v("favorite     ")])],1)],1)])],1)],1)],1)],1)],1)],1)}
var ProductSkeleton_staticRenderFns = []
var ProductSkeleton_esExports = { render: ProductSkeleton_render, staticRenderFns: ProductSkeleton_staticRenderFns }
/* harmony default export */ var ProductSkeleton = (ProductSkeleton_esExports);
// CONCATENATED MODULE: ./src/components/Shared/ProductSkeleton.vue
function ProductSkeleton_injectStyle (ssrContext) {
  __webpack_require__("lFLT")
}
var ProductSkeleton_normalizeComponent = __webpack_require__("VU/8")
/* script */
var ProductSkeleton___vue_script__ = null
/* template */

/* template functional */
var ProductSkeleton___vue_template_functional__ = false
/* styles */
var ProductSkeleton___vue_styles__ = ProductSkeleton_injectStyle
/* scopeId */
var ProductSkeleton___vue_scopeId__ = "data-v-39811339"
/* moduleIdentifier (server only) */
var ProductSkeleton___vue_module_identifier__ = null
var ProductSkeleton_Component = ProductSkeleton_normalizeComponent(
  ProductSkeleton___vue_script__,
  ProductSkeleton,
  ProductSkeleton___vue_template_functional__,
  ProductSkeleton___vue_styles__,
  ProductSkeleton___vue_scopeId__,
  ProductSkeleton___vue_module_identifier__
)

/* harmony default export */ var Shared_ProductSkeleton = (ProductSkeleton_Component.exports);

// CONCATENATED MODULE: ./src/main.js














vue_runtime_esm["a" /* default */].use(vuetify_default.a);

vue_runtime_esm["a" /* default */].component("app-alert", components_Shared_Alert);
vue_runtime_esm["a" /* default */].component("app-edit-product-details-dialog", Product_Edit_EditProductDetailsDialog);
vue_runtime_esm["a" /* default */].component("heart-flutter", Shared_Heart);
vue_runtime_esm["a" /* default */].component("product-skeleton", Shared_ProductSkeleton);

vue_runtime_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_runtime_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  render: function render(h) {
    return h(src_App);
  },
  created: function created() {
    var _this = this;

    firebase["initializeApp"]({
      apiKey: "AIzaSyCEnIlJH29JvA-2wS9cd1_9NUjvQBlzf9Y",
      authDomain: "furniture-site-d9a32.firebaseapp.com",
      databaseURL: "https://furniture-site-d9a32.firebaseio.com",
      projectId: "furniture-site-d9a32",
      storageBucket: "furniture-site-d9a32.appspot.com"
    });
    firebase["auth"]().onAuthStateChanged(function (user) {
      if (user) {
        _this.$store.dispatch("autoSignIn", user);
        _this.$store.dispatch("fetchUserData");
        _this.$store.dispatch("loadAllProducts");
      }
    });
  }
});

/***/ }),

/***/ "QCv7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lFLT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ltkf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p646":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tQcb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tlyz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.272da8e5c950a236dc43.js